import React, { useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { t, Trans } from '@lingui/macro'
import { linkBuilder } from 'shared/linkBuilder'
import { notification } from 'front-end/src/components/common/notifications/Notifications'
import {
  Box,
  ButtonOutline,
  ButtonPrimary,
  Flex
} from 'front-end/src/components'
import Loader from '../../../../components/common/loader/Loader'
import { SurveySendModal } from './SurveySendModal'
import { SurveySendPublishModal } from './SurveySendPublishModal'
import SurveySendTable from './SurveySendTable'
import { brandColors } from 'shared/basicPalette'
import EmptyGroupLogo from 'public/assets/img/empty-group.svg'
import {
  SurveyParticipantsContext,
  WithSurveyParticipantsContext
} from './WithSurveyParticipantsContext'
import { ManageSurveyContext } from '../ManageSurveyContext'

const SurveysSendView = () => {
  const { survey } = React.useContext(ManageSurveyContext)
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false)
  const [showSendModal, setShowSendModal] = useState<boolean>(false)

  const {
    refetchUsers,
    loading,
    survey: data
  } = React.useContext(SurveyParticipantsContext)

  const participantsCount = data?.participantsCount

  if (loading && !participantsCount) {
    return <Loader />
  }

  if (!survey) {
    return null
  }

  const { host, protocol } = location

  const surveyUrl = `${protocol}//${host}${linkBuilder.surveyUrl(survey.id)}`
  return (
    <>
      <Flex alignItems="center" justifyContent="flex-end">
        {!!participantsCount && (
          <>
            <Box color={brandColors.grey.mid} fontSize={'sm'} mr="16px">
              <Trans>
                Access via this link is only available to people in the list
                below.
              </Trans>
            </Box>

            <CopyToClipboard
              text={surveyUrl}
              onCopy={() =>
                notification.info(t`Link successfully copied to the clipboard`)
              }
            >
              <ButtonOutline>
                <Trans>Copy link</Trans>
              </ButtonOutline>
            </CopyToClipboard>
          </>
        )}

        <ButtonPrimary
          ml="4px"
          className="SurveySend__createButton"
          disabled={!survey.questions.length || !!survey.completed_at}
          onClick={() => {
            if (survey.published_at) {
              setShowSendModal(true)
            } else {
              setShowConfirmation(true)
            }
          }}
        >
          <Trans>Share</Trans>
        </ButtonPrimary>
      </Flex>

      {participantsCount ? (
        <SurveySendTable />
      ) : (
        <div className="no-items">
          <img src={EmptyGroupLogo} alt={t`Empty group`} />
          <h3>
            <Trans>No recipients</Trans>
          </h3>
        </div>
      )}

      <SurveySendPublishModal
        show={showConfirmation}
        onCancel={() => setShowConfirmation(false)}
        setShowSendModal={setShowSendModal}
      />
      <SurveySendModal
        show={showSendModal}
        onCancel={() => setShowSendModal(false)}
        onSubmitted={async () => refetchUsers()}
      />
    </>
  )
}

export const SurveySend: React.FC = () => {
  return (
    <WithSurveyParticipantsContext>
      <SurveysSendView />
    </WithSurveyParticipantsContext>
  )
}
